/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-08 13:21:18
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { xAxisLabelColor, yAxisLabelColor } from "../visualConfig";


export default ({ label, list = [], color = [] }) => {
  return {
    color,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    legend: {
      bottom: 10,
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: 50,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: label,
      axisLabel: { ...xAxisLabelColor },
    },
    yAxis: [
      {
        type: 'value',
        axisLabel: { ...yAxisLabelColor },
        axisLine: { show: false },
        axisTick: { show: false },
        minorTick: { show: false },
        splitLine: { show: false },
      },
      {
        type: 'value',
        axisLabel: { ...yAxisLabelColor },
        axisLine: { show: false },
        axisTick: { show: false },
        minorTick: { show: false },
        splitLine: { show: false },
      }
    ],
    series: list.map((item, index) => {
      const isBar = index < list.length / 2;
      console.log(item);

      return {
        name: item.title,
        type: isBar ? 'bar' : 'line',
        data: item.list,
        yAxisIndex: isBar ? 0 : 1,
      }
    })
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P5/chart.js